export default __webpack_public_path__ + "static/media/mt.23b8e8ec.svg";